export const incidentDeliveryTracking = {
  title: {
    type: {
      allIncidentDeliveries: 'Todas as Logísticas Reversas',
      pendingIncidentDeliveries: 'Pendência de Confirmação',
      groupedIncidentItems: 'Logísticas Futuras',
    },
  },
};
